
import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule } from "@ngx-translate/core";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { LoggerService } from "@teammood/shared/util/logger";
import { TeamService } from '../../team.service';
import { Team, TeamSettings } from '../../team.type';
import { TeamDefaultsSettingsFormComponent } from "../team-defaults-settings-form/team-defaults-settings-form.component";

@Component({
    selector: 'team-defaults-settings-dialog',
    templateUrl: './team-defaults-settings-dialog.component.html',
    styleUrls: ['./team-defaults-settings-dialog.component.scss'],
    imports: [
    TranslateModule,
    MatDialogModule,
    MatSelectModule,
    ReactiveFormsModule,
    TeamDefaultsSettingsFormComponent
],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        TeamService
    ]
})
export class TeamDefaultsSettingsDialogComponent {

    updatedTeam: Team

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TeamData,
        public dialogRef: MatDialogRef<TeamDefaultsSettingsDialogComponent, Team>,
        private snackBarService: SnackBarService,
        private teamService: TeamService,
        private logger: LoggerService,
    ) { }

    async onUpdate(newTeamSettings: TeamSettings): Promise<void> {
        const updatedTeam = { ...this.data.team, ...newTeamSettings }
        if (updatedTeam.moodsDisplayTime.time === null || updatedTeam.moodsDisplayTime.timeZone === null) {
            updatedTeam.moodsDisplayTime = null
        }

        try {
            await this.teamService.update(updatedTeam);
            this.updatedTeam = updatedTeam;
            this.snackBarService.success('teamUpdated');
        } catch (error) {
            this.logger.error(error.data);
        }
    }

    close() {
        this.dialogRef.close(this.updatedTeam);
    }
}

export interface TeamData {
    team: Team
}